import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store, createSelector } from '@ngrx/store';

import { BehaviorSubject, switchMap } from 'rxjs';

import { FreyaCommonModule } from '../../../../freya-common/freya-common.module';
import { JOB_LOCATION_TYPES, LocationType } from '../../../../global.constants';
import { formatLocationToDisplay } from '../../../../jobs/jobs.util';
import { formatLocationDetails } from '../../../job-locations-helpers';
import { JobLocationsOverviewActions } from '../overview-locations.actions';
import { overviewLocationsFeature } from '../overview-locations.feature';

@Component({
  selector: 'app-overview-location-details',
  standalone: true,
  imports: [
    FreyaCommonModule,
  ],
  templateUrl: './overview-location-details.component.html',
  styleUrl: './overview-location-details.component.scss'
})
export class OverviewLocationDetailsComponent {

  private _locationType$ = new BehaviorSubject<LocationType>(null);

  @Input() set locationType(value: LocationType) {
    this._locationType$.next(value);
    this.formattedLocationType = JOB_LOCATION_TYPES
      .find((lt) => lt.key === value)?.label || value;
  }

  get locationType(): LocationType {
    return this._locationType$.value;
  }

  @Input() isActive: boolean = false;

  @Output() locationClicked = new EventEmitter<void>();

  public actions = JobLocationsOverviewActions;

  public formattedLocationType: string;

  constructor(
    public store: Store,
  ) {}

  viewModel$ = this._locationType$.pipe(
    switchMap((locationType) => {

      const selectLocationEditor = createSelector(
        overviewLocationsFeature.selectLocationEditors,
        (editors) => editors[locationType],
      );

      return this.store.select(createSelector({
        fields: createSelector(
          selectLocationEditor,
          (editor) => {

            if (locationType !== 'start' && locationType !== 'end') {
              return;
            }

            return formatLocationDetails(editor).join(' | ');
          }
        ),
        accessNotes: createSelector(
          selectLocationEditor,
          (editor) => editor?.accessNotes?.trim() || undefined,
        ),
        address: createSelector(
          selectLocationEditor,
          (editor) => {
            if (!editor?.selectedLocation) {
              return '';
            }

            const primaryAddress = formatLocationToDisplay(editor.selectedLocation, true)?.trim() || '';

            return [ editor.unitNumber, primaryAddress ].filter(Boolean).join(' - ');
          },
        ),
      }));
    }),
  );

  get icon() {
    return this.locationType === 'dock' ? 'pi pi-home' : 'pi pi-map-marker';
  }

  onLocationClick(): void {
    this.locationClicked.emit();
  }
}
